<template>
  <div class="exclamation">
    <EmptyList />
    <p>
      <span v-once v-html="infoText"></span>
    </p>
  </div>
</template>

<script>
import EmptyList from '@/assets/svg/common/img_empty.svg'
export default {
  name: 'MyPooqEmptyList',
  components: {
    EmptyList
  },
  props: {
    infoText: {
      type: String
    }
  }
}
</script>
